import script from "./NavbarTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavbarTop.vue?vue&type=script&lang=ts&setup=true"

import "./NavbarTop.vue?vue&type=style&index=0&id=a3ba5260&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3ba5260"]])

export default __exports__